import React from "react"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Form from "react-bootstrap/Form"

import { Feedback } from "../../../../../components/Validator"

const defaultRangeId = "defaultNumberRangeProperty"
const minRangeId = "minNumberRangeProperty"
const maxRangeId = "maxNumberRangeProperty"

interface ConfigureNumberProps {
  default?: string
  min?: string
  max?: string
  valid: Feedback
  disabled: boolean
  setDisabled: (value: boolean) => void
  onUpdate: () => void
  setDefault: (id: string, e: any, valueType?: "Number" | "Decimal") => void
  setMin: (id: string, e: any, isDecimal?: boolean) => void
  setMax: (id: string, e: any, isDecimal?: boolean) => void
}

const ConfigureNumber = (props: ConfigureNumberProps) => {
  const disabledDefault =
    props.disabled || (!props.valid.valid && props.valid.id !== defaultRangeId)
  const disabledMin =
    props.disabled || (!props.valid.valid && props.valid.id !== minRangeId)
  const disabledMax =
    props.disabled || (!props.valid.valid && props.valid.id !== maxRangeId)

  const inValidDefault = props.valid.id === defaultRangeId
  const inValidMin = props.valid.id === minRangeId
  const inValidMax = props.valid.id === maxRangeId

  const setDefault = (e: any) => props.setDefault(defaultRangeId, e, "Number")
  const setMin = (e: any) => props.setMin(minRangeId, e)
  const setMax = (e: any) => props.setMax(maxRangeId, e)

  return (
    <Form>
      <Form.Group as={Row} controlId={defaultRangeId}>
        <Form.Label column={true} md="3">
          Default
        </Form.Label>
        <Col md="9">
          <Form.Control
            type="number"
            step={1}
            min={props.min || -2147483648}
            max={props.max || 2147483647}
            value={props.default || ""}
            onChange={setDefault}
            onBlur={props.onUpdate}
            disabled={disabledDefault}
            isInvalid={inValidDefault}
          />
          <Form.Control.Feedback type="invalid">
            {props.valid.message}
          </Form.Control.Feedback>
          <Form.Text>
            An optional default value. Leave empty if none should be set.
          </Form.Text>
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId={minRangeId}>
        <Form.Label column={true} md="3">
          Minimum
        </Form.Label>
        <Col md="9">
          <Form.Control
            type="number"
            step={1}
            min={-2147483648}
            max={props.max || 2147483647}
            value={props.min || ""}
            onChange={setMin}
            onBlur={props.onUpdate}
            disabled={disabledMin}
            isInvalid={inValidMin}
          />
          <Form.Control.Feedback type="invalid">
            {props.valid.message}
          </Form.Control.Feedback>
          <Form.Text>
            An optional minimum value. Leave empty if none should be set.
          </Form.Text>
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId={maxRangeId}>
        <Form.Label column={true} md="3">
          Maximum
        </Form.Label>
        <Col md="9">
          <Form.Control
            type="number"
            step={1}
            min={props.min || -2147483648}
            max={2147483647}
            value={props.max || ""}
            onChange={setMax}
            onBlur={props.onUpdate}
            disabled={disabledMax}
            isInvalid={inValidMax}
          />
          <Form.Control.Feedback type="invalid">
            {props.valid.message}
          </Form.Control.Feedback>
          <Form.Text>
            An optional maximum value. Leave empty if none should be set.
          </Form.Text>
        </Col>
      </Form.Group>
    </Form>
  )
}

export default ConfigureNumber
